module.exports = __webpack_public_path__ + "static/github-icon-c4715f0c5558af23f64c3e3e6e26584d.png";